import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesProfileMain } from './modules/ui/Main';

const ProfilePage = (
  <SuspensePage>
    <PagesProfileMain />
  </SuspensePage>
);

export default ProfilePage;
